import template from './index.html'
import ko from 'knockout'

function init (params) {
  this.multiple = params.multiple
  this.subList = ko.observableArray([])
  this.data = params.data
  this.isLoading = function (val) {
    if (val) {
      return val()
    } else {
      return false
    }
  }
  this.selectedValue = params.selectedValue
  this.loadData = params.loadData
  this.activeIndex = ko.observable(-1)
  this.casitmevisible = params.casitmevisible
  this.expandChild = (event, data, index) => {
    // 再次点击本节点不刷新数据
    if (this.loadData) {
      // 异步加载
      if (data.isLoaded) {
        // 根据isLoaded 标志判断是否已经加载数据，如果已经加载那就直接显示
        return this.subList(data.children)
      }
      this.subList([])
      this.data().forEach((item) => {
        item.isLoading(false)
      })
      data.isLoading(true)
      this.loadData(data, (childrenData) => {
        data.isLoading(false)
        if (childrenData && childrenData.length > 0) {
          childrenData.forEach((item) => {
            item.isLoading = ko.observable(false)
          })
          data.children = childrenData
          data.isLoaded = true
          this.subList(childrenData)
        } else {
          this.subList([])
          // 如果支持多选，不隐藏下拉菜单，直接return
          if (this.multiple()) return
          this.casitmevisible(false)
        }
      })
    } else {
      // 静态数据加载
      if (data.children && data.children.length > 0) {
        this.subList(data.children)
      } else {
        this.subList([])
        // 如果支持多选，不隐藏下拉菜单，直接return
        if (this.multiple()) return
        this.casitmevisible(false)
      }
    }
    this.activeIndex(index)
    // 如果支持多选 如何改变selectedValue的值
    if (this.multiple()) {
      // 表示末级，末级可以选择
      if (!data.leafNode) return;
      let selectedValue = this.selectedValue()
      let position = selectedValue.findIndex(item => item.id === data.id)
      if (position >= 0) {
        selectedValue.splice(position, 1)
        return this.selectedValue(selectedValue)
      }
      return this.selectedValue(selectedValue.concat(data))
    }
    this.selectedValue(data)
  }
}
export default {
  name: 'casitem',
  init,
  template
}



// WEBPACK FOOTER //
// ./src/components/casitem/index.js